/** When taxable, require at least one non–pre-tax tax id. */
export function validateVariationPriceTaxes(
  state: { taxable?: boolean },
  taxesValue: any,
  preTaxFeeTaxIdSet: ReadonlySet<string>,
): boolean {
  if (!state.taxable) {
    return true
  }
  const selectedIds = Array.isArray(taxesValue) ? taxesValue : []
  return selectedIds.some((taxId) => !preTaxFeeTaxIdSet.has(taxId))
}
